import { Enumeration, Feature, StatusItem } from "./interface";

export const formatEnumsForDropDown = (enums: Enumeration[]) => {
  return enums.map((type: Enumeration) => ({
    value: type.enumId,
    label: type.description,
  }));
};

export const formateFeaturesForDropdown = (features: Feature[]) => {
  return features.map((feature: Feature) => ({
    value: feature.propertyFeatureId,
    label: feature.description,
  }))
};

export const formatStatuesForDropDown = (statues: StatusItem[]) => {
  return statues.map((status: StatusItem) => ({
    value: status.statusId,
    label: status.description,
  }));
};
